export interface AccessDeniedProps {
  /** A category from the Worker — never an address. */
  reason?: string;
}

const COPY: Record<string, { heading: string; body: string }> = {
  disabled: {
    heading: 'Rubric Score is switched off right now.',
    body: 'This is not about your account. The 240 Labs team has taken the tool down for everyone, usually for a few minutes while something is fixed. Try again shortly.',
  },
  session_invalid: {
    heading: 'We could not verify your sign-in.',
    body: 'You are signed in, but the server could not confirm it. That is usually configuration rather than permission — if you are running this locally, check that the Clerk publishable key and issuer come from the same instance.',
  },
  unreachable: {
    heading: 'We could not reach 240 Labs.',
    body: 'The server did not answer. Reload in a moment; if it keeps happening, something is down rather than restricted.',
  },
};

const FALLBACK = {
  heading: 'Not open to your account.',
  body: 'Ask the 240 Labs team if you were expecting access.',
};

export default function AccessDenied({ reason }: AccessDeniedProps) {
  const copy = (reason && COPY[reason]) || FALLBACK;
  return (
    <div className="notice" role="status">
      <h2>{copy.heading}</h2>
      <p>{copy.body}</p>
    </div>
  );
}
